<template>
  <footer>
    <span>Drag and drop to reorder list</span>
  </footer>
</template>

<script>
  export default { name: 'TheFooter' }
</script>

<style>

footer {
  isolation: isolate;
}

footer > span {
  display: block;
  color: var(--footer-text-clr);
  font-size: .8rem;
  margin-top: 64px;
}

</style>